import { http } from "../../../services/http.service";

export const getStatistics = () =>
  http({
    url: "statistics",
    method: "GET",
    auth: true,
  });
